export enum TASK_BUNDLE_OPERATION_MODES {
  CREATE = 'create',
  EDIT = 'edit',
  CLONE = 'clone',
}
